export default {
      id: "icon-app_settings-usage",
      viewBox: "0 0 16 16",
      url: "/" + "assets/sprite.svg#icon-app_settings",
      toString: function () {
        return this.url;
      }
    }